import React from 'react';

class IconBoxPanel extends React.Component {
  render() {
    const {
      show_icon,
      icon_class,
      hide_title,
      title,
      body,
      show_details_button,
      details_button_text,
      onDetailsButtonClick,
      show_selector_button,
      selector_button_text,
      onSelectorButtonClick,
      height,
      CustomComponent,
      type,
      container_class_name
    } = this.props;

    return (
      <div className={container_class_name || ''}>
        <section className='panel'>
    			<header className={`panel-heading bg-${type || 'primary'}`}>
    				<div className='panel-heading-icon'>
    					<i className={icon_class} />
    				</div>
    			</header>
    			<div className='panel-body text-center'>
    				{!title ? <h3 className='text-weight-semibold mt-sm text-center'>{title}</h3> : null}
    				{body ? <p className='text-center'>{body}</p> : null}
            {show_details_button ? (
              <p>
                <a
                  className='lnk-primary learn-more'
                  onClick={onDetailsButtonClick}
                  >
                  {details_button_text || 'Learn More'}{'  '}<i className='fa fa-angle-right' />
                </a>
              </p>
            ) : null}
            {show_selector_button ? (
              <Button onClick={onSelectorButtonClick}>{selector_button_text}</Button>
            ) : null}
            {CustomComponent ? CustomComponent : null}
    			</div>
    		</section>
      </div>
    );
  }
}

export default IconBoxPanel;



// WEBPACK FOOTER //
// ./src/browser/components/ui/icon-box-panel.js